<div>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">بررسی اطلاعات تانکر</h2>
      </div>

      <div class="modal-body">
        <h2>اطلاعات را وارد کنید</h2>

        <div class="form-group has-icon">
          <span class="form-control-icon">
            <mat-icon>phone_iphone</mat-icon>
          </span>
          <input
            type="search"
            class="form-control"
            [ngClass]="strMobile ? 'direction-ltr' : ''"
            [disabled]="isSubmitDisabled"
            #strMobileField="ngModel"
            [(ngModel)]="strMobile"
            required
            appPhoneNumberValidation
            [maxLength]="11"
            [minlength]="11"
            placeholder="شماره موبایل"
            inputmode="numeric"
            appNumericOnly
            (keydown.enter)="submit(strMobileField)"
            autofocus
          />
        </div>
      </div>

      <div class="modal-footer d-flex flex-row-reverse justify-content-end">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="
            strMobileField.invalid ||
            strMobileField.pristine ||
            isSubmitDisabled
          "
          (click)="submit(strMobileField)"
        >
          بررسی
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Dtails Dialog -->
<ng-template #detailsDialogTemplate let-modal>
  <ng-container>
    <div class="modal-header">
      <h2 class="modal-title">نمایش اطلاعات تانکر</h2>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.close()"
      ></button>
    </div>
    <div class="modal-body">
      <div class="grid-container">
        <div class="field-wrapper">
          <label for="name-field">نام</label>
          <input
            type="text"
            class="form-control"
            readonly
            id="name-field"
            [value]="tankerProfile.strName || '-'"
          />
        </div>
        <div class="field-wrapper">
          <label for="family-field">نام خانوادگی</label>
          <input
            type="text"
            class="form-control"
            readonly
            id="family-field"
            [value]="tankerProfile.strFamily || '-'"
          />
        </div>
        <div class="field-wrapper">
          <label for="national-id-field">کد ملی مالک تانکر</label>
          <input
            type="text"
            class="form-control direction-ltr"
            readonly
            id="national-id-field"
            [value]="tankerProfile.strID || '-'"
          />
        </div>
        <div class="field-wrapper">
          <label for="date-field">تاریخ ثبت</label>
          <input
            type="text"
            class="form-control direction-ltr"
            readonly
            id="date-field"
            [value]="tankerProfile.strRegisterDateTime || '-'"
          />
        </div>
        <div class="field-wrapper">
          <label for="vehicle-type-field">نوع خودرو</label>
          <input
            type="text"
            class="form-control"
            readonly
            id="vehicle-type-field"
            [value]="tankerProfile.strGPSType_strComment || '-'"
          />
        </div>
        <div class="field-wrapper">
          <label for="vehicle-no-field">پلاک</label>
          <input
            type="text"
            class="form-control"
            readonly
            id="vehicle-no-field"
            [value]="tankerProfile.strVehicleNo || '-'"
          />
        </div>
        <div class="field-wrapper">
          <label for="city-field">شهر</label>
          <input
            type="text"
            class="form-control"
            readonly
            id="city-field"
            [value]="tankerProfile.strCityName || '-'"
          />
        </div>
        <div class="field-wrapper">
          <label for="state-field">آدرس</label>
          <input
            type="text"
            class="form-control"
            readonly
            id="state-field"
            [value]="tankerProfile.strAddress || '-'"
          />
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
